import { render, staticRenderFns } from "./Capacitacion.vue?vue&type=template&id=75a126fa&scoped=true"
import script from "./Capacitacion.vue?vue&type=script&lang=js"
export * from "./Capacitacion.vue?vue&type=script&lang=js"
import style0 from "./Capacitacion.vue?vue&type=style&index=0&id=75a126fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a126fa",
  null
  
)

export default component.exports